/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowDim1DiagRightIcon24Solid = forwardRef('ArrowDim1DiagRightIcon24Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { d: "M13.5 1.625a1.375 1.375 0 1 0 0 2.75h4.18L4.375 17.68V13.5a1.375 1.375 0 1 0-2.75 0v6.25a2.625 2.625 0 0 0 2.625 2.625h6.25a1.375 1.375 0 1 0 0-2.75H6.32L19.625 6.32v4.18a1.375 1.375 0 1 0 2.75 0V4.25a2.625 2.625 0 0 0-2.625-2.625H13.5Z" })));
});
